import React, { createContext, useContext, useMemo, useState } from 'react';
import { translations } from '../data/translations';
import type { Language, Translation } from '../types/i18n';
interface LanguageContextValue {
  language: Language;
  setLanguage: (language: Language) => void;
  t: Translation;
}
const LanguageContext = createContext<LanguageContextValue | undefined>(undefined);
export function LanguageProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [language, setLanguage] = useState<Language>('fr');
  const value = useMemo(() => ({
    language,
    setLanguage,
    t: translations[language]
  }), [language]);
  return <LanguageContext.Provider value={value} data-id="element-297" data-mp="1392y9toabdxp">
      {children}
    </LanguageContext.Provider>;
}
export function useLanguage(): LanguageContextValue {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}